import React from 'react';
import { Typography, Breadcrumbs } from '@mui/material';
import { trakrefFontFamily } from '../../../utils';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import {Grey5} from "../../../color_utils";
import { useHistory } from "react-router-dom";

const translatedText = (intl, text) => {
    if (typeof text === 'string' && text.includes("#")) {
        const id = (text && text.split("#")[1]);
        switch (text.split("#")[0].trim()) {
            case "Work Order":
                return `${intl.formatMessage({ id: "kanbanFilters.workorder" })} #${id}`;
            case "Service Event":
                return `${intl.formatMessage({ id: "serviceActivityView.service-event" })} #${id}`;
            case "Location":
                return `${intl.formatMessage({ id: "serviceEventsView.location" })} #${id}`;
            case "Inventory":
                return `${intl.formatMessage({ id: "serviceEventsView.inventory" })} #${id}`;
            default:
                return text;
        }
    } else {
        switch (text) {
            case "Work Orders":
                return intl.formatMessage({ id: "assetdetailsmaintab.workOrder"});
            case "Service Events":
                return intl.formatMessage({ id : "serviceActivityView.service-events"});
            case "Location":
                return intl.formatMessage({ id : "serviceEventsView.location"});
            case "Inventory":
                return intl.formatMessage({ id: "serviceEventsView.inventory" });
            case "Edit":
                return intl.formatMessage({ id: "propertyUseDetailsView.edit"});
            default:
                return text;
        }
    }
};

const BreadCrumbs = ({
    path = [],
    sx = {},
}) => {
    const intl = useIntl();
    const history = useHistory();

    const renderTypography = (obj) => (
        <Typography
            sx={{
                // pass "onClick: null" to prevent cursor from being a pointer on a non-clickable item
                '&:hover': {
                    cursor: !!obj.to ? 'pointer' : '',
                    textDecoration: !!obj.to || !!obj.onClick ? 'underline' : '',
                }
            }}
            style={{ fontSize: '0.7rem' }}
        >
            {translatedText(intl,obj.text)}
        </Typography>
    );

    return (
        <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
            sx={{ marginBottom: '1%', ...sx }}
        >
            {path.map((obj, index) => (
                obj.to ? (
                    <Link 
                        key={index} 
                        to={obj.to} 
                        onClick={(e) => { 
                            e.preventDefault(); 
                            history.replace(obj.to); 
                        }}
                        style={{ color: Grey5 }}
                    >
                        {renderTypography(obj)}
                    </Link>
                ) : obj.onClick ? (
                    <div key={index} onClick={obj.onClick} style={{ cursor: 'pointer', color: Grey5 }}>
                        {renderTypography(obj)}
                    </div>
                ) : (
                    <span key={index} style={{ color: Grey5 }}>
                        {renderTypography(obj)}
                    </span>
                )
            ))}
        </Breadcrumbs>
    )
};

BreadCrumbs.propTypes = {
    path: PropTypes.array.isRequired,
    sx: PropTypes.object,
};
  
export default BreadCrumbs;
